export default Object.freeze({
  SubscriptionInvoicePaid: 1,
  AICreditPurchasePaid: 2,
  AIAutoRechargePaid: 3,
  AIManualCreditPurchasePaid: 4,
});
